import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

@Component({
  selector: 'aid-table-header',
  template: `
    <div
      class="full-width aid-layout-row aid-layout-align-space-between-center"
    >
      <div
        class="aid-layout-row aid-layout-align-start-center aid-layout-gap-16"
      >
        @if (!!goBackText) {
          <div
            class="header__back aid-layout-row aid-layout-align-start-center"
            (click)="back.emit()"
          >
            <mat-icon
              class="header__back--color"
              svgIcon="new_arrow_ios_back"
            ></mat-icon>
            <span class="mat-small"> {{ goBackText | translate }}</span>
          </div>
        }
        <div class="mat-headline-6">{{ title | translate }}</div>
        <ng-content></ng-content>
      </div>

      <div
        class="header__search-filter full-height aid-layout-row aid-layout-align-end-end aid-layout-gap-16"
      >
        @if (canSearch) {
          <aid-search
            [canFilter]="canFilter"
            [searchPlaceholder]="searchPlaceholder"
            (search)="search.emit($event)"
            class="header__search-filter__search-box"
          ></aid-search>
        }

        @if (filters && hasFilters) {
          <mat-chip-listbox class="full-height">
            <div
              class="header__search-filter__chips full-height aid-layout-row aid-layout-align-center-center"
            >
              @for (filter of filters | unsortedKeys; track filter) {
                <mat-chip-option
                  (click)="onRemoveFilter(filter)"
                  [disableRipple]="true"
                  class="full-height header__chip-color"
                  [matTooltip]="filters[filter] | translate"
                  matTooltipPosition="above"
                >
                  @if (!truncateText) {
                    <span> {{ filters[filter] | translate }}</span>
                  }
                  @if (truncateText) {
                    <span class="truncate-text">
                      {{
                        truncateTextFunction(filters[filter] | translate)
                      }}</span
                    >
                  }
                  <mat-icon
                    class="header__chip-icon"
                    matChipRemove
                    (click)="onRemoveFilter(filter)"
                    svgIcon="close"
                  ></mat-icon>
                </mat-chip-option>
              }
            </div>
          </mat-chip-listbox>
        }

        <ng-content select="[aidTableHeaderButtons]"></ng-content>

        @if (canFilter) {
          <button
            class="aid-icon-only-button"
            type="button"
            mat-stroked-button
            color="white"
            onclick="blur()"
            (click)="onFilter()"
          >
            <mat-icon class="icon" svgIcon="filter"></mat-icon>
          </button>
        }
        <ng-container *aidHasPermission="permissions">
          @if (canAdd) {
            <button
              mat-raised-button
              color="primary"
              class="aid-icon-only-button plus-button"
              (click)="add.emit()"
            >
              <mat-icon data-cy="add-project-btn" svgIcon="add"></mat-icon>
            </button>
          }
        </ng-container>
      </div>
    </div>
  `,
  styleUrls: ['./table-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TableHeaderComponent implements OnInit {
  @Input() title?: string;
  @Input() canAdd = true;
  @Input() canFilter = false;
  @Input() permissions?: string[];
  @Input() canSearch = true;
  @Input() goBackText?: string;
  @Input() searchPlaceholder = 'search';
  @Input() truncateText = false;

  @Input() filters?: { [id: string]: string | undefined };

  @Output() add = new EventEmitter();
  @Output() search = new EventEmitter<string>();
  @Output() back = new EventEmitter();
  @Output() filter = new EventEmitter();
  @Output() removeFilter = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {}

  get hasFilters() {
    return this.filters && Object.keys(this.filters).length > 0;
  }

  onFilter() {
    this.filter.emit();
  }

  onRemoveFilter(filterId: string) {
    this.removeFilter.emit(filterId);
  }

  truncateTextFunction(
    text: string | null | undefined,
    maxLength: number = 23
  ): string {
    if (!text) {
      return '';
    }
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  }
}
